export interface ConfigurationOptionsItem {
    file: string;
    uploadAt: string;
    link: string;
    source?: string;
    provider?: string;
};